

























































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'ConfirmProjectUpdateModal',
    components: {},
})
export default class ConfirmProjectUpdateModal extends Vue {
    @Prop() private affectedData: Map<string, number>;
    @Prop() private name: string;
    @Prop() private localizationKey: string;

    private confirmText: string = '';

    public confirm() {
        this.$emit('toggleConfirmUpdateModal', true);
    }

    public toggleConfirmUpdateModal() {
        this.$emit('toggleConfirmUpdateModal', false);
    }

    get isConfirmed() {
        return this.confirmText.toLowerCase() === 'confirm' || this.confirmText.toLowerCase() === 'bestätigen';
    }
}
